<template>
  <v-layout class="justify-center" column>
    <v-flex xs12 v-for="(file, index) in files" :key="file.name">
      <v-card flat class="text-center">
        <v-card-text class="di-flex align-center py-2 brdr-b">
          <v-icon class="px-3">{{
            "mdi-file" + getFileIcon(file.name)
          }}</v-icon>
          <div class="caption">
            {{ file.name.substr(0, 20) + "..." + getFileExtension(file.name) }}
          </div>
          <v-spacer />
          <v-icon
            @click="deleteItem(file, index)"
            v-if="(file.id && userCan('delete_files')) || !file.id"
            >delete_outline</v-icon
          >
          <v-icon @click="downloadFile(file)" v-if="file.id"
            >mdi-download</v-icon
          >
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  methods: {
    getFileIcon(file) {
      const extention = this.getFileExtension(file).toLowerCase();

      switch (extention) {
        case "pdf":
          return "-pdf";
          break;
        case "doc":
        case "docx":
          return "-word";
          break;
        case "jpg":
        case "png":
        case "jpeg":
          return "-image";
          break;
        default:
          return "";
      }
    },
    getFileExtension(filename) {
      return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
    },
    downloadFile(file, index) {
      if (file.id)
        this.axios
          .get(`files/${file.id}`, {
            responseType: "blob", // important
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", file.name);
            document.body.appendChild(link);
            link.click();
          });
    },
    deleteItem(file, index) {
      let vm = this;
      if (file.id)
        this.$alert("files/" + file.id).then(() => {
          vm.files.splice(vm.files.indexOf(file), 1);
        });
      else this.files.splice(index, 1);
    },
  },
};
</script>

<style scoped>
</style>